import currentDate from './currentDate';
import datetimePicker from './datetimePicker';
import datetimeRangePicker from './datetimeRangePicker';
import directoryTree from './directoryTree';
import directoryTreeSelectDirectory from './directoryTreeSelectDirectory';
import directoryTreeSelectDocument from './directoryTreeSelectDocument';
import documentPreviewDocument from './documentPreviewDocument';
import documentPreviewVersion from './documentPreviewVersion';
import documentUpload from './documentUpload';
import dtFooter from './dtFooter';
import formAutofillFix from './formAutofillFix';
import formElementInputCaptcha from './formElements/inputCaptcha';
import formElementInputCheckbox from './formElements/inputCheckbox';
import formElementInputDatetime from './formElements/inputDatetime';
import formElementInputDocumentUpload from './formElements/inputDocumentUpload';
import formElementInputDropdown from './formElements/inputDropdown';
import formElementInputHidden from './formElements/inputHidden';
import formElementInputMultiline from './formElements/inputMultiline';
import formElementInputNumerical from './formElements/inputNumerical';
import formElementInputRadio from './formElements/inputRadio';
import formElementInputText from './formElements/inputText';
import formElementStaticDocumentDownload from './formElements/staticDocumentDownload';
import formElementStaticDocumentPreview from './formElements/staticDocumentPreview';
import formElementStaticText from './formElements/staticText';
import iboxTools from './iboxTools';
import icheck from './icheck';
import idBadge from './idBadge';
import impersonateUser from './impersonateUser';
import minimalizeSidebar from './minimalizeSidebar';
import navbarStaff from './navbar/staff';
import navbarSupportWorker from './navbar/supportWorker';
import onlineUsers from './onlineUsers';
import pageHeader from './pageHeader';
import pageTitle from './pageTitle';
import preferences from './preferences';
import report from './report';
import {load as loadReports} from './report/reports';
import sidebar from './sidebar';
import sidebarStaff from './sidebar/staff';
import sidebarSupportWorker from './sidebar/supportWorker';
import statusIfErrored from './status/ifErrored';
import statusIfLoaded from './status/ifLoaded';
import statusIfLoading from './status/ifLoading';
import statusIfUnloaded from './status/ifUnloaded';

export const load = (app) => {
	app.directive('currentDate', currentDate);
	app.directive('datetimePicker', datetimePicker);
	app.directive('datetimeRangePicker', datetimeRangePicker);
	app.directive('directoryTree', directoryTree);
	app.directive('directoryTreeSelectDirectory', directoryTreeSelectDirectory);
	app.directive('directoryTreeSelectDocument', directoryTreeSelectDocument);
	app.directive('documentPreviewDocument', documentPreviewDocument);
	app.directive('documentPreviewVersion', documentPreviewVersion);
	app.directive('documentUpload', documentUpload);
	app.directive('dtFooter', dtFooter);
	app.directive('formAutofillFix', formAutofillFix);
	app.directive('iboxTools', iboxTools);
	app.directive('icheck', icheck);
	app.directive('idBadge', idBadge);
	app.directive('impersonateUser', impersonateUser);
	app.directive('minimalizeSidebar', minimalizeSidebar);
	app.directive('navbarSupportWorker', navbarSupportWorker);
	app.directive('navbarStaff', navbarStaff);
	app.directive('onlineUsers', onlineUsers);
	app.directive('pageHeader', pageHeader);
	app.directive('pageTitle', pageTitle);
	app.directive('preferences', preferences);
	app.directive('report', report);
	app.directive('sidebar', sidebar);
	app.directive('sidebarSupportWorker', sidebarSupportWorker);
	app.directive('sidebarStaff', sidebarStaff);
	app.directive('statusIfErrored', statusIfErrored);
	app.directive('statusIfLoaded', statusIfLoaded);
	app.directive('statusIfLoading', statusIfLoading);
	app.directive('statusIfUnloaded', statusIfUnloaded);
	app.directive('formElementInputCaptcha', formElementInputCaptcha);
	app.directive('formElementInputCheckbox', formElementInputCheckbox);
	app.directive('formElementInputDatetime', formElementInputDatetime);
	app.directive('formElementInputDocumentUpload', formElementInputDocumentUpload);
	app.directive('formElementInputDropdown', formElementInputDropdown);
	app.directive('formElementInputHidden', formElementInputHidden);
	app.directive('formElementInputMultiline', formElementInputMultiline);
	app.directive('formElementInputNumerical', formElementInputNumerical);
	app.directive('formElementInputRadio', formElementInputRadio);
	app.directive('formElementInputText', formElementInputText);
	app.directive('formElementStaticDocumentDownload', formElementStaticDocumentDownload);
	app.directive('formElementStaticDocumentPreview', formElementStaticDocumentPreview);
	app.directive('formElementStaticText', formElementStaticText);

	loadReports(app);
};


// WEBPACK FOOTER //
// ./src/js/directives/loader.js